import getIn from 'transmute/getIn';
import { COMPANY_INDUSTRY_PROPERTY_NAME, TABLE_COMPANY_PROPERTIES } from '../../constants/properties';
import { useCompanyProperties } from '../../hooks/properties';
import { PropertyCell } from 'framework-data-table';
import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

//@ts-expect-error untyped

import { EmptyStateCell } from './EmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyIndustryCell = ({
  value,
  requiredCellProps,
  associatedObject
}) => {
  const {
    loading,
    properties,
    error
  } = useCompanyProperties(TABLE_COMPANY_PROPERTIES);
  if (loading || error) {
    return /*#__PURE__*/_jsx(EmptyStateCell, {});
  }
  const propertyDefinition = getIn([COMPANY_INDUSTRY_PROPERTY_NAME], properties);
  return /*#__PURE__*/_jsx(PropertyCell, {
    value: value,
    objectTypeId: COMPANY_TYPE_ID,
    objectId: associatedObject.objectId,
    propertyDefinition: propertyDefinition,
    canEditObject: false,
    getSecondaryPropertyValue: () => undefined,
    requiredCellProps: requiredCellProps
  });
};